import React, { useCallback, useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import Icon from 'react-icons-kit'
import { chevronLeft } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'
// import { dateFormate } from '../../../../utils/helpers'

import LoadingComponent from '../../../../components/loading/Index'

const Show = () => {
    const { id } = useParams()
    const [isLoading, setLoading] = useState(true)
    const [item, setItem] = useState(null)
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Fetch data
    const fetchData = useCallback(async () => {
        const data = await Requests.AboutUs.Show(id, header)
        if (data) {
            setItem(data)
            setLoading(false)
        }
        setLoading(false)
    }, [id, header])


    useEffect(() => {
        fetchData()
    }, [id, header, fetchData])


    if (isLoading) return <LoadingComponent />

    return (
        <div className="store-story pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Show About us</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/about-us"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">

                                <table className="table table-md table-borderless">
                                    <tbody>
                                        <tr>
                                            <td>Paragraph 1</td>
                                            <td>{item.paragraph_1 || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Paragraph 2</td>
                                            <td>{item.paragraph_2 || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Paragraph 3</td>
                                            <td>{item.paragraph_3 || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Paragraph 4</td>
                                            <td>{item.paragraph_4 || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Paragraph 5</td>
                                            <td>{item.paragraph_5 || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Paragraph 6</td>
                                            <td>{item.paragraph_6 || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Paragraph 7</td>
                                            <td>{item.paragraph_7 || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Paragraph 8</td>
                                            <td>{item.paragraph_8 || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Paragraph 9</td>
                                            <td>{item.paragraph_9 || 'N/A'}</td>
                                        </tr>

                                    </tbody>
                                </table>


                                <br />

                                {item.admin ?
                                    <div className="text-end">
                                        <h6><i>Created by</i></h6>
                                        <p className="mb-0">{item.admin.name}</p>
                                        <p className="mb-0">{item.admin.email}</p>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Show;